import styled from 'styled-components';

export const Content = styled.div`

  label{
    display: flex;
    align-items:center;
    background: #fff;
    border: 1px solid #eee;
    width: 100%;

    padding: 0.5rem;
  }

  select{
    flex:1;
    padding: 0.5rem;
    padding-right: 5rem;
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    border-color: transparent;
    font-size: 1.05rem;
  }

`;
